import styled, { css } from "styled-components";

const commonButtonStyles = css`
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	gap: 5px;
	width: 300px;
	height: 40px;
	padding: 0 20px;
	border-radius: 20px;
	opacity: 0.5;

	&:hover {
		opacity: 1;
	}
`;

const commonPaddingStyles = css`
	padding: 90px 20px 0;

	@media (min-width: 1600px) {
		padding: 90px 50px 0;
	}
`;

const promotionBannerPaddingStyles = css`
	padding: 0 20px 0;

	@media (min-width: 1600px) {
		padding: 0 50px 0;
	}
`;

export const TabContentWrapper = styled.div`
	#casino-filters-container {
		${commonPaddingStyles}
		${({ hasCasinoPromotionBanner }) =>
			hasCasinoPromotionBanner && promotionBannerPaddingStyles}
	}
`;

export const ShowMoreGamesButtonWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 20px auto;
	gap: 20px;
`;

export const CasinoShowMoreGamesButton = styled.div`
	${commonButtonStyles}
	background: var(
		--Secondary-Colour-gradient-1,
		linear-gradient(180deg, var(--main-explosive) 0%, var(--main-dark-explosive) 100%)
	);
`;

export const LiveCasinoShowMoreGamesButton = styled.div`
	${commonButtonStyles}
	background: var(--Main-Colour-gradient-1, linear-gradient(180deg, #f0052f 0%, #940136 100%));
`;

export const MoreGamesWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const MoreGamesTitle = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	color: #fff;
	text-align: center;
	font-size: 12px;
	font-weight: 600;
	line-height: 20px;
	letter-spacing: 0.3px;
`;

export const SEALING_WRAPPER = styled.div`
	display: flex;
	background: var(--casino-provider-gradient);
	margin-top: 10px;
	color: var(--main-text-color);
	padding: 20px;
	width: 100%;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	@media (min-width: 1024px) {
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
	}
`;

export const GambleImgWrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	align-items: center;
	justify-content: center;
	gap: 30px;
	width: 100%;

	@media (min-width: 1024px) {
		justify-content: flex-end;
	}
`;

export const Licence = styled.div`
	font-size: 12px;
	font-weight: 700;
	line-height: 20px;
	letter-spacing: 0.3px;
	margin-bottom: 20px;
	text-align: center;
	@media (min-width: 1024px) {
		font-size: 11.5px;
		text-align: start;
		width: 100%;
	}
`;

export const Address = styled.div`
	font-size: 12px;
	font-weight: 400;
	line-height: 20px;
	letter-spacing: 0.3px;
	line-height: 17px;
	margin-bottom: 10px;
	text-align: center;

	@media (min-width: 768px) {
		width: 80%;
	}

	@media (min-width: 1024px) {
		width: 100%;
		margin-bottom: 0;
		text-align: start;
	}
`;

export const LEGAL_WRAPPER = styled.div`
	width: 100%;
	padding: 10px 0;
	display: flex;
	justify-content: center;
	align-items: center;

	&:first-of-type {
		flex-direction: column;
	}
`;
